import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import { IAccordionData } from "@/models/IAccordionData";
import s1Icon from "../../assets/icons/capabilities-preclinical-s1.png";
import s2Icon1 from "../../assets/icons/capabilities-preclinical-s2-1.png";
import s2Icon2 from "../../assets/icons/capabilities-preclinical-s2-2.png";
import s2Icon3 from "../../assets/icons/capabilities-preclinical-s2-3.png";
import s2Icon4 from "../../assets/icons/capabilities-preclinical-s2-4.png";
import s2Icon5 from "../../assets/icons/capabilities-preclinical-s2-5.png";
import s3Icon from "../../assets/icons/capabilities-preclinical-s3.png";
import s4Icon1 from "../../assets/icons/capabilities-pre-clinical-s4-1.png";
import s4Icon2 from "../../assets/icons/capabilities-pre-clinical-s4-2.png";
import s4Icon3 from "../../assets/icons/capabilities-pre-clinical-s4-3.png";
import s4Icon4 from "../../assets/icons/capabilities-pre-clinical-s4-4.png";
import s4Icon5 from "../../assets/icons/capabilities-pre-clinical-s4-5.png";
import s4Icon6 from "../../assets/icons/capabilities-pre-clinical-s4-6.png";
import s5Icon from "../../assets/icons/capabilities-preclinical-s5.png";
import Arrow from "../../components/Arrow";
import AccordionWrapper from "../../components/accordionWrapper";

const accordionDataRaw = [
  {
    header: "Discovery Chemistry",
    description:
      "Compounds are plated and arrive ready for your biologic interrogation platform in most cases.",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "Small Molecule Diversity Library",
        data: "Interrogate biological system using Lilly ExploR&D’s ~ 4,000 small molecules",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Small Molecule Profiling Library",
        data: "Interrogate the effectiveness of selected molecules from the Diversity Library in your biological system",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: <img src={s1Icon} alt="a building" />,
      },
    ],
  },
  {
    header: "Large Molecule Discovery Process",
    data: [
      {
        header: "Therapeutic Modalities",
        headerSection: "Discovery",
        icon: (
          <img src={s2Icon1} alt="Therapeutic Modalities" className="h-12" />
        ),
        data: [
          "Human antibodies",
          "Bispecific antibodies",
          "Fc fusion",
          "Therapeutic proteins/enzymes",
          "VHH",
          "Peptide",
        ],
      },
      {
        icon: <img src={s2Icon2} alt="Assays" className="h-12" />,
        header: "Assays",
        data: [
          "Cell-based and functional assays",
          "Single-cell analytics for receptor density and internalization",
          "Intracellular trafficking and endosome escaping assays",
        ],
      },
      {
        headerSection: "Lead Optimization",
        icon: (
          <img src={s2Icon3} alt="Lead Characterization" className="h-12" />
        ),
        header: "Lead Characterization",
        data: [
          "In silico modeling",
          "Bioassays",
          "Immunogenicity risk assessment",
          "Developability assessment",
        ],
      },
      {
        icon: <img src={s2Icon4} alt="Lead Optimization" className="h-12" />,
        header: "Lead Optimization",
        data: [
          "Engineering for biological activates, developability and low immunogenicity risk",
          "Effector function assessment ",
          "Transition to Contract Development and Manufacturing Organization (CDMO)",
        ],
      },
      {
        headerSection: "Development Candidate",
        icon: <img src={s2Icon5} alt="Enabling Biology" className="h-12" />,
        header: "Enabling Biology",
        data: [
          "Primary cell assays: Peripheral Blood Mononuclear Cells (PBMCs), T & Natural Killer (NK) cells, plasmacytoid dendritic cells (pDCs), neuron, organoid culture, endothelial cells and skin culture",
          "In vitro/ex vivo imaging",
          "Pharmacodynamic (PD) models and intravital imaging",
          "Mouse models for tissue-targeted delivery and oral delivery ",
        ],
      },
    ],
  },
  {
    header: "siRNA Hepatic Delivery",
    data: [
      {
        header: "",
        headerSection: "",
        icon: <></>,
        data: [
          "Hepatic delivery system for small interfering ribonucleic acid (siRNA) delivery",
          "Bioinformatics workflows for siRNA sequence selection",
          "Consultation on strategy, study design and study data",
        ],
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: <img src={s3Icon} alt="a building" />,
      },
    ],
  },
  {
    header: "Small Molecule Drug Development (SMDD)",
    data: [
      {
        header: "Developability",
        headerSection: "Lead Molecules or Scaffolds",
        icon: <img src={s4Icon1} alt="Developability" className="h-12" />,
        data: "Assess developability of leading compounds to select potential development candidates and identify key technical risks",
      },
      {
        icon: (
          <img
            src={s4Icon2}
            alt="Preclinical Formulation Development"
            className="h-12"
          />
        ),
        header: "Preclinical Formulation Development",
        data: "Characterize solid state landscape and identify viable forms for development",
      },
      {
        headerSection: "Development Candidate",
        icon: <img src={s4Icon3} alt="Solid State Design" className="h-12" />,
        header: "Solid State Design",
        data: "Characterize solid state landscape and identify forms for development",
      },
      {
        icon: <img src={s4Icon4} alt="Chemistry Consulting" className="h-12" />,
        header: "Chemistry Consulting",
        data: "In route design and chemical process development",
      },
      {
        icon: <img src={s4Icon5} alt="Drug Product Design" className="h-12" />,
        header: "Drug Product Design",
        data: "Formulation development and drug product prototyping",
      },
      {
        headerSection: "Investigational New Drug (IND)",
        icon: (
          <img
            src={s4Icon6}
            alt="Chemistry, Manufacturing & Control (CMC) Support"
            className="h-12"
          />
        ),
        header: "Chemistry, Manufacturing & Control (CMC) Support",
        data: "Support for manufacture of materials for toxicology and human clinical studies",
      },
    ],
  },
  {
    header: "Structural Biology",
    description: "Cryogenic Electron Microscopy & X-Ray Crystallography",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Bioinformatics and molecular biology for protein construct design, cloning, expression and evaluation",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Biochemistry for protein purification, complex formation, and characterization",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Protein crystallography for structure determination, refinement and analysis",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Analysis of data, images and calculations to solve structures",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: <img src={s5Icon} alt="Molecule" className="h-20" />,
      },
    ],
  },
];

const Preclinical = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //Discovery Chemistry
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light max-w-[40rem]">
            {accordionDataRaw[0].description}
          </div>
          <div className="my-8 grid lg:grid-cols-6 grid-cols-1 gap-4 lg:gap-2 items-center">
            <div className="lg:col-span-5 col-span-6 w-full h-full lg:block">
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-2 h-full ">
                {accordionDataRaw[0].data.map((el, index) => (
                  <>
                    {index !== accordionDataRaw[0].data.length - 1 ? (
                      <div className="h-full">
                        <CapabilitiesTextContainer>
                          <div className="font-medium mb-2">{el.header}</div>
                          <div>{el.data}</div>
                        </CapabilitiesTextContainer>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                ))}
              </div>
            </div>

            <div className="col-span-6 lg:col-span-1 flex w-full h-full items-center justify-center">
              <img src={s1Icon} alt="a building" className="h-32" />
            </div>
          </div>
        </div>
      ),
    },
    {
      header: accordionDataRaw[1].header,
      body: (
        <>
          <div className="p-4">
            <div className="my-8 xl:grid-cols-6 grid-cols-1 gap-2 hidden xl:grid">
              {accordionDataRaw[1].data.map((el, index) => (
                <>
                  {index !== accordionDataRaw[1].data.length - 1 ? (
                    <div className="flex flex-col justify-end">
                      <div className="flex flex-col justify-center align-baseline w-full relative">
                        {el.headerSection && (
                          <div
                            className={`mb-8 text-lg font-semibold flex w-full ${index === 2 ? "justify-center" : ""}`}
                          >
                            <div
                              className="w-fit"
                              id={`headerSection-s2-${index + 1}`}
                            >
                              {el.headerSection}
                            </div>
                          </div>
                        )}
                        <div className="w-full">
                          <div className="w-fit" id={`icon-s2-${index + 1}`}>
                            {el.icon}
                            {index === 2 && (
                              <div
                                className="h-0 w-0 bg-red-500 absolute left-1/2 bottom-6"
                                id={`marker-s2-3`}
                              ></div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-span-2">
                      <div className="flex flex-col justify-center align-baseline w-full">
                        {el.headerSection && (
                          <div
                            className={`mb-8 text-lg font-semibold flex justify-end`}
                          >
                            <div className="w-fit" id={`headerSection-s2-5`}>
                              {el.headerSection}
                            </div>
                          </div>
                        )}
                        <div className="w-full relative">
                          <div className="w-fit" id={`icon-s2-${index + 1}`}>
                            {el.icon}
                            <div
                              className="h-0 w-0 bg-red-500 absolute right-0 top-1/2"
                              id={`marker-s2-5`}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ))}
              {accordionDataRaw[1].data.map((el, index) => (
                <>
                  {index !== accordionDataRaw[1].data.length - 1 ? (
                    <div className="flex flex-col">
                      <CapabilitiesTextContainer>
                        <div className="font-medium mb-2">{el.header}</div>
                        <ul className="px-4">
                          {Array.isArray(el.data) &&
                            el.data.map((point) => (
                              <li className="py-1">{point}</li>
                            ))}
                        </ul>
                      </CapabilitiesTextContainer>
                    </div>
                  ) : (
                    <div className="col-span-2">
                      <CapabilitiesTextContainer>
                        <div className="font-medium mb-2">{el.header}</div>
                        <ul className="px-4">
                          {Array.isArray(el.data) &&
                            el.data.map((point) => (
                              <li className="py-1">{point}</li>
                            ))}
                        </ul>
                      </CapabilitiesTextContainer>
                    </div>
                  )}
                </>
              ))}
            </div>
            {props.accordionOpenHeader === accordionDataRaw[1].header && (
              <div className="hidden xl:block">
                <Arrow
                  fromId="headerSection-s2-1"
                  toId="icon-s2-1"
                  dashed
                  type="mobile"
                />
                <Arrow fromId="icon-s2-1" toId="icon-s2-2" />
                <Arrow fromId="icon-s2-2" toId="icon-s2-3" />
                <Arrow
                  fromId="headerSection-s2-3"
                  toId="marker-s2-3"
                  dashed
                  type="mobile"
                  fromMiddle
                />
                <Arrow fromId="icon-s2-3" toId="icon-s2-4" />
                <Arrow fromId="icon-s2-4" toId="icon-s2-5" />
                <Arrow fromId="icon-s2-5" toId="marker-s2-5" dashed />
                <Arrow
                  toId="marker-s2-5"
                  fromId="headerSection-s2-5"
                  dashed
                  type="mobile"
                  fromEnd
                />
              </div>
            )}
            <div className="my-8 flex flex-col gap-2 xl:hidden w-full">
              {accordionDataRaw[1].data.map((el, index) => (
                <div>
                  {index === 0 && (
                    <div
                      className="mb-8 font-semibold"
                      id={`headerSection-s2-${index + 1}-mobile`}
                    >
                      {el.headerSection}
                    </div>
                  )}
                  <div className="flex gap-4 w-full">
                    <div
                      className="w-12 min-w-12 h-fit"
                      id={`icon-s2-${index + 1}-mobile`}
                    >
                      {el.icon}
                    </div>
                    <div className="flex-grow">
                      <CapabilitiesTextContainer>
                        <div className="font-medium mb-2">{el.header}</div>
                        <ul className="px-4">
                          {Array.isArray(el.data) &&
                            el.data.map((point) => (
                              <li className="py-1">{point}</li>
                            ))}
                        </ul>
                      </CapabilitiesTextContainer>
                    </div>
                  </div>
                  {index !== 0 && (
                    <>
                      <div className="relative">
                        {(index === 2 || index === 4) && (
                          <div
                            className="h-0 w-0 bg-red-500 absolute top-1/2 left-6"
                            id={`marker-s2-${index + 1}-mobile`}
                          ></div>
                        )}
                        <div
                          className="ml-16 my-8 pl-2 font-semibold w-fit"
                          id={`headerSection-s2-${index + 1}-mobile`}
                        >
                          {el.headerSection}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}
              {props.accordionOpenHeader === accordionDataRaw[1].header && (
                <div className="xl:hidden block">
                  <Arrow
                    fromId="headerSection-s2-1-mobile"
                    toId="icon-s2-1-mobile"
                    dashed
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s2-1-mobile"
                    toId="icon-s2-2-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s2-2-mobile"
                    toId="icon-s2-3-mobile"
                    type="mobile"
                  />
                  <Arrow
                    toId="headerSection-s2-3-mobile"
                    fromId="marker-s2-3-mobile"
                    dashed
                  />
                  <Arrow
                    fromId="icon-s2-3-mobile"
                    toId="icon-s2-4-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s2-4-mobile"
                    toId="icon-s2-5-mobile"
                    type="mobile"
                  />
                  <Arrow
                    toId="icon-s2-5-mobile"
                    fromId="marker-s2-5-mobile"
                    dashed
                    type="mobile"
                    fromMiddle
                  />
                  <Arrow
                    fromId="marker-s2-5-mobile"
                    toId="headerSection-s2-5-mobile"
                    dashed
                  />
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
    //siRNA
    // {
    //   header: accordionDataRaw[2].header,
    //   body: (
    //     <div className="p-4">
    //       <div className="my-8 grid xl:grid-cols-3 grid-cols-1 gap-4 xl:gap-2 items-center">
    //         {accordionDataRaw[2].data.map((el, index) => (
    //           <>
    //             {index < accordionDataRaw[2].data.length - 1 ? (
    //               <div className="h-full xl:col-span-2">
    //                 <CapabilitiesTextContainer>
    //                   <div className="font-medium mb-2">{el.header}</div>
    //                   <ul className="px-4">
    //                     {Array.isArray(el.data) &&
    //                       el.data.map((point) => (
    //                         <li className="py-1">{point}</li>
    //                       ))}
    //                   </ul>
    //                 </CapabilitiesTextContainer>
    //               </div>
    //             ) : (
    //               <div className="flex w-full h-full items-center justify-center">
    //                 <img src={s3Icon} alt="a liver" className="h-36" />
    //               </div>
    //             )}
    //           </>
    //         ))}
    //       </div>
    //     </div>
    //   ),
    // },
    //Small Molecule
    {
      header: accordionDataRaw[3].header,
      body: (
        <>
          <div className="p-4">
            <div className="my-8 xl:grid-cols-6 grid-cols-1 gap-2 hidden xl:grid">
              {accordionDataRaw[3].data.map((el, index) => (
                <>
                  <div className="flex flex-col justify-end">
                    <div className="flex flex-col justify-center align-baseline w-full relative">
                      {el.headerSection && (
                        <div
                          className={`mb-8 text-lg font-semibold flex w-full ${index === 2 ? "justify-center" : ""}`}
                        >
                          <div
                            className={
                              index !== 5 ? "w-fit" : "w-full text-right"
                            }
                            id={`headerSection-s4-${index + 1}`}
                          >
                            {el.headerSection}
                          </div>
                        </div>
                      )}
                      <div className="w-full">
                        <div className="w-fit" id={`icon-s4-${index + 1}`}>
                          {el.icon}
                          {index === 2 && (
                            <div
                              className="h-0 w-0 bg-red-500 absolute left-1/2 bottom-6"
                              id={`marker-s4-3`}
                            ></div>
                          )}
                          {index === 5 && (
                            <div
                              className="h-0 w-0 bg-red-500 absolute right-0 bottom-6"
                              id={`marker-s4-6`}
                            ></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
              {accordionDataRaw[3].data.map((el, index) => (
                <div className="flex flex-col">
                  <CapabilitiesTextContainer>
                    <div className="font-medium mb-2">{el.header}</div>
                    {el.data}
                  </CapabilitiesTextContainer>
                </div>
              ))}
            </div>
            {props.accordionOpenHeader === accordionDataRaw[3].header && (
              <div className="hidden xl:block">
                <Arrow
                  fromId="headerSection-s4-1"
                  toId="icon-s4-1"
                  dashed
                  type="mobile"
                />
                <Arrow fromId="icon-s4-1" toId="icon-s4-2" />
                <Arrow fromId="icon-s4-2" toId="icon-s4-3" />
                <Arrow
                  fromId="headerSection-s4-3"
                  toId="marker-s4-3"
                  dashed
                  type="mobile"
                  fromMiddle
                />
                <Arrow fromId="icon-s4-3" toId="icon-s4-4" />
                <Arrow fromId="icon-s4-4" toId="icon-s4-5" />
                <Arrow fromId="icon-s4-5" toId="icon-s4-6" />
                <Arrow fromId="icon-s4-6" toId="marker-s4-6" dashed />
                <Arrow
                  toId="marker-s4-6"
                  fromId="headerSection-s4-6"
                  dashed
                  type="mobile"
                  fromEnd
                />
              </div>
            )}
            <div className="my-8 flex flex-col gap-2 xl:hidden w-full">
              {accordionDataRaw[3].data.map((el, index) => (
                <div>
                  {index === 0 && (
                    <div
                      className="mb-8 font-semibold"
                      id={`headerSection-s4-${index + 1}-mobile`}
                    >
                      {el.headerSection}
                    </div>
                  )}
                  <div className="flex gap-4 w-full">
                    <div
                      className="w-12 min-w-12 h-fit "
                      id={`icon-s4-${index + 1}-mobile`}
                    >
                      {el.icon}
                    </div>
                    <div className="flex-grow">
                      <CapabilitiesTextContainer>
                        <div className="font-medium mb-2">{el.header}</div>
                        {el.data}
                      </CapabilitiesTextContainer>
                    </div>
                  </div>
                  {index !== 0 && (
                    <>
                      <div className="relative">
                        {(index === 2 || index === 5) && (
                          <div
                            className="h-0 w-0 bg-red-500 absolute top-1/2 left-6"
                            id={`marker-s4-${index + 1}-mobile`}
                          ></div>
                        )}
                        <div
                          className="ml-16 my-8 pl-2 font-semibold w-fit"
                          id={`headerSection-s4-${index + 1}-mobile`}
                        >
                          {el.headerSection}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}
              {props.accordionOpenHeader === accordionDataRaw[3].header && (
                <div className="xl:hidden block">
                  <Arrow
                    fromId="headerSection-s4-1-mobile"
                    toId="icon-s4-1-mobile"
                    dashed
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s4-1-mobile"
                    toId="icon-s4-2-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s4-2-mobile"
                    toId="icon-s4-3-mobile"
                    type="mobile"
                  />
                  <Arrow
                    toId="headerSection-s4-3-mobile"
                    fromId="marker-s4-3-mobile"
                    dashed
                  />
                  <Arrow
                    fromId="icon-s4-3-mobile"
                    toId="icon-s4-4-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s4-4-mobile"
                    toId="icon-s4-5-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s4-5-mobile"
                    toId="icon-s4-6-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s4-6-mobile"
                    toId="marker-s4-6-mobile"
                    type="mobile"
                    fromMiddle
                    dashed
                  />
                  <Arrow
                    fromId="marker-s4-6-mobile"
                    toId="headerSection-s4-6-mobile"
                    dashed
                  />
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
    //Structural Biology
    {
      header: accordionDataRaw[4].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light">
            {accordionDataRaw[4].description}
          </div>
          <div className="my-8 grid xl:grid-cols-5 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[4].data.map((el, index) => (
              <div className="h-full">
                {index !== accordionDataRaw[4].data.length - 1 ? (
                  <div className="h-full">
                    <CapabilitiesTextContainer>
                      <div>{el.data}</div>
                    </CapabilitiesTextContainer>
                  </div>
                ) : (
                  <div className="flex w-full h-full items-center px-8 mt-4 xl:mt-0 xl:justify-start justify-center">
                    <img src={s5Icon} alt="Molecule" className="h-32" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      setOpen={props.setAccordionOpenHeader}
      accordionOpenHeader={props.accordionOpenHeader}
    />
  );
};

export default Preclinical;
